import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { getTermsPage } from "../../../SHARED/actions/pages.actions";
import Parser from 'html-react-parser'
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';

class Terms extends Component {
    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getTermsPage();
    }

    componentDidMount() {
        pageViewEvent('Termeni şi condiţii', window.location.href);
     }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Termeni şi condiţii</title>
                    <meta name="description" content={this.props.terms.body && this.props.terms.body.substring(this.props.terms.body.indexOf('<h1>'),this.props.terms.body.indexOf('</h1>')).replace( /(<([^>]+)>)/ig, '')} />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
                <div className="container-fluid grey-text">
                    <div className="confidentiality-page">
                        { this.props.terms.body && Parser(this.props.terms.body) }
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    terms: state.pages.terms
});

export default connect(mapStateToProps, {getTermsPage})(Terms);





// WEBPACK FOOTER //
// ./src/FO/components/terms/terms.component.js